export default __webpack_public_path__ + "static/media/984.3c7cc51d.png";